export const formatUtils = {
  formatMoney: (value: number | null | undefined) => {
    if (value === null || value === undefined) {
      return " ---";
    }

    if (isNaN(value)) {
      return " ---";
    }

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(value);
  },
  formatNumber: (value: number | null | undefined, whole?: boolean) => {
    if (value === null || value === undefined) {
      return " ---";
    }

    if (isNaN(value)) {
      return " ---";
    }

    return new Intl.NumberFormat(
      "en-US",
      whole
        ? {}
        : {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
    ).format(value);
  },
  toTitleCase: (value: string) => {
    return (
      value.charAt(0).toUpperCase() + value.substring(1).toLocaleLowerCase()
    );
  },
};
